// extracted by mini-css-extract-plugin
export default {"AlertIcon":"VideoDurationAlertIcon_AlertIcon__HdAgb"};